import Immutable from 'immutable';
import { createSelector } from 'reselect';
import { selectAuthorSuggestionEntities, selectCatalogBibEntities, selectListEntities } from '../EntitiesSelector';
import { constructSeries } from './SeriesInfoSelector';

const getDiscoveryItemsByType = type => state => state.getIn(['bibs', 'discovery', type, 'items'], Immutable.List());
const getDiscoveryPaginationByType = type => state =>
  state.getIn(['bibs', 'discovery', type, 'pagination'], Immutable.Map());

const getSeriesMetadata = state => state.getIn(['bibs', 'discovery', 'seriesInfo']) || Immutable.Map();

export const selectRecommendationsForCurrentBib = createSelector(
  [getDiscoveryItemsByType('recommendations')],
  recommendations => recommendations
);

export const selectRelatedTitlesForCurrentBib = createSelector(
  [getDiscoveryItemsByType('relatedTitles'), selectCatalogBibEntities],
  (ids, catalogBibEntities) => ids.map(id => catalogBibEntities.get(id))
);

export const selectAuthorSuggestionsForCurrentBib = createSelector(
  [getDiscoveryItemsByType('authorSuggestions'), selectAuthorSuggestionEntities],
  (authorSuggestionIds, authorSuggestionsEntities) =>
    authorSuggestionIds.map(suggestionId => authorSuggestionsEntities.get(suggestionId.toString()))
);

export const selectSeriesInfoForCurrentBib = constructSeries(getSeriesMetadata);

export const selectStaffListsForCurrentBib = createSelector(
  [getDiscoveryItemsByType('staffLists'), selectListEntities],
  (listIds, listEntities) => listIds.map(listId => listEntities.get(listId.toString()))
);

export const selectCommunityListsForCurrentBib = createSelector(
  [getDiscoveryItemsByType('communityLists'), selectListEntities],
  (listIds, listEntities) => listIds.map(listId => listEntities.get(listId.toString()))
);

export const selectCommunityListsPagination = createSelector(
  [getDiscoveryPaginationByType('communityLists')],
  pagination => pagination
);
